import { z } from 'zod';

/** Verplichte envelop van elk domeinevent (docs/conventions/events.md). */
export const actorSchema = z.object({
  type: z.enum(['person', 'platform_admin', 'system']),
  id: z.guid().nullable(),
});
export type Actor = z.infer<typeof actorSchema>;

export const eventEnvelopeSchema = z.object({
  eventId: z.guid(),
  occurredAt: z.string().datetime(),
  tenantId: z.guid().nullable(),
  actor: actorSchema,
  version: z.number().int().min(1),
});
export type EventEnvelope = z.infer<typeof eventEnvelopeSchema>;

/** Voegt de envelop toe aan een payloadvorm. */
export function eventSchema<T extends z.ZodRawShape>(payload: T) {
  return eventEnvelopeSchema.extend(payload);
}
